var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// I18n comes from Sprockets now
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const { I18n } = window;
/**
 * Host-injected translation override global. Bracket-indexed via this constant
 * to avoid the `no-underscore-dangle` lint rule on dot access.
 */
const CHAT_WIDGET_TRANSLATIONS_KEY = '__IP_CHAT_WIDGET_TRANSLATIONS__';
/**
 * Resolves a dot-path key against a nested object, returning the value at
 * that path or `undefined` if any segment is missing.
 */
function dotPathLookup(obj, path) {
    return path.split('.').reduce((node, segment) => {
        if (node !== null && typeof node === 'object') {
            return node[segment];
        }
        return undefined;
    }, obj);
}
/**
 * Substitutes Rails-style `%{param}` placeholders in an override string.
 * `window.I18n.t` does this for the Sprockets tier; without it, hosts using
 * the override dictionary (e.g. the Technician Portal) would render literal
 * `%{noun}` text. Unknown placeholders are left as-is.
 */
function interpolate(template, params) {
    return template.replace(/%\{(\w+)\}/g, (match, name) => Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match);
}
export const translate = (key, params) => {
    const { namespace } = params, paramsRest = __rest(params, ["namespace"]);
    const prefix = namespace ? `${namespace}.` : undefined;
    const fullKey = `${prefix || ''}${key}`;
    // The chat widget bundle is also embedded in non-Rails hosts (e.g. the
    // technician-portal Angular app) where Sprockets does not inject the I18n
    // global. Returning the key keeps SSE progress handlers from throwing while
    // still letting the host fall back to its own labels.
    if (!I18n || typeof I18n.t !== 'function') {
        // Tier 2: host-injected override dictionary (populated via `translationOverrides`
        // mount option by cross-origin hosts such as the Technician Portal).
        const overrides = window[CHAT_WIDGET_TRANSLATIONS_KEY];
        if (overrides) {
            const value = dotPathLookup(overrides, fullKey);
            if (typeof value === 'string') {
                return interpolate(value, paramsRest);
            }
            if (Array.isArray(value) && value.length > 0) {
                const idx = Math.floor(Math.random() * value.length);
                const picked = value[idx];
                if (typeof picked === 'string') {
                    return interpolate(picked, paramsRest);
                }
            }
        }
        // Tier 3: raw key (last-ditch label so SSE progress handlers never throw).
        return fullKey;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    return I18n.t(fullKey, paramsRest);
};
/**
 * Gets the current language from the I18n global object
 * @returns The current language code (e.g., 'en', 'es', 'fr')
 */
export const getCurrentLanguage = () => {
    // Default to English if I18n is not available
    if (!I18n) {
        return 'en';
    }
    try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
        return I18n.locale || 'en';
    }
    catch (error) {
        console.error('Error getting current language:', error);
        return 'en';
    }
};
export default I18n;
